import api from "@/api/api";
import {logout} from "@/helpers";

export function salvar(parametros) {
  return api.post('drp/analise-parametros-produto/produtos', parametros)
    .then(() => {})
    .catch(logout)
}
